// 허용 URI 목록을 환경 변수에서 가져온다(미설정 시 DOMPurify 기본 동작).
const allowedUris = process.env.NEXT_PUBLIC_ALLOWED_URIS
  ? process.env.NEXT_PUBLIC_ALLOWED_URIS.split(",").map(uri =>
      uri.replace(/[-\\/\\^$*+?.()|[\]{}]/g, "\\$&")
    )
  : undefined;

export const ALLOWED_URI_REGEXP = allowedUris
  ? new RegExp(`^(${allowedUris.join("|")})$`)
  : undefined;
